import { FC } from "react";

import { FormStep } from "../steps";

import { PasswordInput } from "../../../components/Interaction/PasswordInput";

import { RenderLabel } from "./RenderLabel";
import { INPUT_CLASSNAME } from "./constants";

export type PasswordFormElementProps = {
  password: string;
  setValue: (value: string) => void;
  currentStep: FormStep;
};

export const PasswordFormElement: FC<PasswordFormElementProps> = ({
  password,
  setValue,
  currentStep,
}) => {
  const { name: identifier, title } = currentStep;

  return (
    <>
      <RenderLabel identifier={identifier} title={title} required={true} />

      <PasswordInput
        value={password}
        minLength={6}
        onChange={({ target }) => setValue(target.value)}
        autoComplete="current-password"
        id={identifier}
        className={`${INPUT_CLASSNAME}`}
        required
      />
    </>
  );
};
